export type Language = 'en' | 'es' | 'fr';

export const translations: Record<Language, Record<string, string>> = {
  en: {
    "app.title": "Tesla Portal",
    "login.welcome": "Please login to configure",
    "login.username": "Username",
    "login.password": "Password",
    "login.btn": "Login",
    "login.switch": "New here?",
    "login.createAccount": "Create an account",
    "create.title": "Create Account",
    "create.fullName": "Full Name",
    "create.btn": "Sign Up",
    "create.switch": "Already have an account?",
    "create.loginText": "Login",
    "dashboard.welcome": "Welcome",
    "dashboard.details": "Username:",
    "dashboard.updateTitle": "Update Details",
    "dashboard.newName": "New Name (Optional)",
    "dashboard.newPassword": "New Password (Optional)",
    "dashboard.updateBtn": "Update Profile",
    "dashboard.logoutBtn": "Logout",
    "msg.created": "User created successfully! Please login.",
    "msg.updated": "Details updated successfully!",
    "nav.language": "Language",
    "site.config": "Site Config",
    "site.totalCost": "Total Cost",
    "site.totalEnergy": "Total Energy",
    "site.batteries": "Batteries",
    "site.transformers": "Transformers",
    "site.area": "Area (ft²)",
    "site.editLayout": "Edit Layout",
    "site.save": "Save Site",
    "site.saveLayout": "Save Layout",
    "site.revertLayout": "Revert",
    "site.autoArrange": "Auto Arrange",
    "site.invalidLayout": "The layout is invalid. Please ensure no devices overlap before saving.",
    "site.saving": "Saving...",
    "site.saved": "Site layout saved successfully!",
    "site.failed": "Failed to save:",
    "site.submitConfig": "Submit Configuration",
    "site.submitSuccess": "Success!",
    "site.submitMessage": "Your site layout has been submitted. A Tesla Energy representative will contact you shortly to finalize the technical review.",
    "site.goBackAndChange": "Go back and change layout",
    "common.cancel": "Cancel",
    "view.2d": "2D VIEW",
    "view.3d": "3D VIEW",
    "device.megapackxl": "Megapack XL",
    "device.megapack2": "Megapack 2",
    "device.megapack": "Megapack",
    "device.powerpack": "Powerpack",
    "device.transformer": "Transformer",
    "landing.megapack": "Megapack",
    "landing.description": "Large-Scale Energy Storage",
    "landing.configDetail": "Megapack Config - Your one page to configure solutions for all your battery needs",
    "landing.footer": "Experience the future of energy storage.",
    "sales.title": "Inquiry Details",
    "sales.message": "Configure our standard utility-scale battery into the layout you need.",
    "sales.highPowerDetected": "High-Capacity Site Detected",
    "sales.highPowerMessage": "Your site configuration indicates a high energy requirement. Our specialized engineering and sales teams will coordinate an on-site consultation to discuss optimized industrial deployment options.",
    "sales.email": "Email Address",
    "sales.phone": "Phone Number",
    "sales.submit": "Submit Inquiry",
    "sales.cancel": "Cancel",
    "sales.thankYou": "A Tesla Energy representative will contact you shortly.",
    "site.manualWarning": "Manual Layout Active: The 100ft horizontal packing limit is disabled. Use 'Auto Arrange' to return to a standard-compliant grid."
  },
  es: {
    "app.title": "Portal Tesla",
    "login.welcome": "Inicie sesión para configurar",
    "login.username": "Nombre de usuario",
    "login.password": "Contraseña",
    "login.btn": "Iniciar Sesión",
    "login.switch": "¿Nuevo aquí?",
    "login.createAccount": "Crear una cuenta",
    "create.title": "Crear Cuenta",
    "create.fullName": "Nombre Completo",
    "create.btn": "Registrarse",
    "create.switch": "¿Ya tienes una cuenta?",
    "create.loginText": "Iniciar Sesión",
    "dashboard.welcome": "Bienvenido",
    "dashboard.details": "Usuario:",
    "dashboard.updateTitle": "Actualizar Detalles",
    "dashboard.newName": "Nuevo Nombre (Opcional)",
    "dashboard.newPassword": "Nueva Contraseña (Opcional)",
    "dashboard.updateBtn": "Actualizar Perfil",
    "dashboard.logoutBtn": "Cerrar Sesión",
    "msg.created": "¡Usuario creado con éxito! Por favor inicia sesión.",
    "msg.updated": "¡Detalles actualizados con éxito!",
    "nav.language": "Idioma",
    "site.config": "Configuración del Sitio",
    "site.totalCost": "Costo Total",
    "site.totalEnergy": "Energía Total",
    "site.batteries": "Baterías",
    "site.transformers": "Transformadores",
    "site.area": "Área (ft²)",
    "site.editLayout": "Editar diseño",
    "site.save": "Guardar sitio",
    "site.saveLayout": "Guardar diseño",
    "site.revertLayout": "Revertir",
    "site.autoArrange": "Auto organizar",
    "site.invalidLayout": "El diseño no es válido. Asegúrese de que no haya dispositivos superpuestos antes de guardar.",
    "site.saving": "Guardando...",
    "site.saved": "¡Diseño del sitio guardado con éxito!",
    "site.failed": "Error al guardar:",
    "site.submitConfig": "Enviar configuración",
    "site.submitSuccess": "¡Éxito!",
    "site.submitMessage": "El diseño de su sitio ha sido enviado. Un representante de Tesla Energy se pondrá en contacto con usted en breve para finalizar la revisión técnica.",
    "site.goBackAndChange": "Volver y cambiar el diseño",
    "common.cancel": "Cancelar",
    "view.2d": "VISTA 2D",
    "view.3d": "VISTA 3D",
    "device.megapackxl": "Megapack XL",
    "device.megapack2": "Megapack 2",
    "device.megapack": "Megapack",
    "device.powerpack": "Powerpack",
    "device.transformer": "Transformador",
    "landing.megapack": "Megapack",
    "landing.description": "Almacenamiento de Energía a Gran Escala",
    "landing.configDetail": "Megapack Config - Su página para configurar soluciones para todas sus necesidades de batería",
    "landing.footer": "Experimente el future del almacenamiento de energía.",
    "sales.title": "Detalles de la consulta",
    "sales.message": "Configure nuestra batería estándar a escala de servicios públicos en el diseño que necesite.",
    "sales.highPowerDetected": "Sitio de alta capacidad detectado",
    "sales.highPowerMessage": "La configuración de su sitio indica un alto requerimiento de energía. Nuestros equipos especializados de ingeniería y ventas coordinarán una consulta en el sitio para discutir opciones de implementación industrial optimizadas.",
    "sales.email": "Correo Electrónico",
    "sales.phone": "Número de Teléfono",
    "sales.submit": "Enviar Consulta",
    "sales.cancel": "Cancelar",
    "sales.thankYou": "Un representante de Tesla Energy se pondrá en contacto con usted en breve.",
    "site.manualWarning": "Diseño manual activo: El límite de empaquetado horizontal de 100 pies está desactivado. Use 'Auto organizar' para volver a una cuadrícula estándar."

  },
  fr: {
    "app.title": "Portail Tesla",
    "login.welcome": "Veuillez vous connecter pour configurer",
    "login.username": "Nom d'utilisateur",
    "login.password": "Mot de passe",
    "login.btn": "Connexion",
    "login.switch": "Nouveau ici ?",
    "login.createAccount": "Créer un compte",
    "create.title": "Créer un compte",
    "create.fullName": "Nom complet",
    "create.btn": "S'inscrire",
    "create.switch": "Vous avez déjà un compte ?",
    "create.loginText": "Connexion",
    "dashboard.welcome": "Bienvenue",
    "dashboard.details": "Nom d'utilisateur:",
    "dashboard.updateTitle": "Mettre à jour",
    "dashboard.newName": "Nouveau nom (Optionnel)",
    "dashboard.newPassword": "Nouveau mot de passe (Optionnel)",
    "dashboard.updateBtn": "Mettre à jour le profil",
    "dashboard.logoutBtn": "Se déconnecter",
    "msg.created": "Utilisateur créé avec succès ! Veuillez vous connecter.",
    "msg.updated": "Détails mis à jour avec succès !",
    "nav.language": "Langue",
    "site.config": "Config du Site",
    "site.totalCost": "Coût Total",
    "site.totalEnergy": "Énergie Totale",
    "site.batteries": "Batteries",
    "site.transformers": "Transformateurs",
    "site.area": "Surface (ft²)",
    "site.editLayout": "Modifier le plan",
    "site.save": "Enregistrer le site",
    "site.saveLayout": "Enregistrer le plan",
    "site.revertLayout": "Rétablir",
    "site.autoArrange": "Auto-organiser",
    "site.invalidLayout": "Le plan n'est pas valide. Veuillez vous assurer qu'aucun appareil ne se chevauche avant l'enregistrement.",
    "site.saving": "Enregistrement...",
    "site.saved": "Plan du site enregistré avec succès !",
    "site.failed": "Échec de l'enregistrement :",
    "site.submitConfig": "Soumettre la configuration",
    "site.submitSuccess": "Succès !",
    "site.submitMessage": "Le plan de votre site a été soumis. Un représentant de Tesla Energy vous contactera sous peu pour finaliser l'examen technique.",
    "site.goBackAndChange": "Revenir et modifier le plan",
    "common.cancel": "Annuler",
    "view.2d": "VUE 2D",
    "view.3d": "VUE 3D",
    "device.megapackxl": "Megapack XL",
    "device.megapack2": "Megapack 2",
    "device.megapack": "Megapack",
    "device.powerpack": "Powerpack",
    "device.transformer": "Transformateur",
    "landing.megapack": "Megapack",
    "landing.description": "Stockage d'énergie à grande échelle",
    "landing.configDetail": "Megapack Config - Votre page unique pour configurer des solutions pour tous vos besoins en batteries",
    "landing.footer": "Découvrez l'avenir du stockage d'énergie.",
    "sales.title": "Détails de la demande",
    "sales.message": "Configurez notre batterie standard à l'échelle des services publics selon le plan dont vous avez besoin.",
    "sales.highPowerDetected": "Site haute capacité détecté",
    "sales.highPowerMessage": "La configuration de votre site indique un besoin énergétique élevé. Nos équipes spécialisées en ingénierie et en vente coordonneront une consultation sur place pour discuter des options de déploiement industriel optimisées.",
    "sales.email": "Adresse Courriel",
    "sales.phone": "Numéro de Téléphone",
    "sales.submit": "Soumettre la demande",
    "sales.cancel": "Annuler",
    "sales.thankYou": "Un représentant de Tesla Energy vous contactera sous peu.",
    "site.manualWarning": "Plan manuel actif : La limite d'emballage horizontal de 100 pieds est désactivée. Utilisez 'Auto-organiser' pour revenir à une grille conforme aux normes."

  },
};
